import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { getEnv, resolveIdentifier, getRoot } from 'mobx-state-tree';
import { getSession } from '@jbrowse/core/util';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const useStyles = makeStyles()(theme => ({
    dialogContent: {
        width: '80em',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));
export default function SearchResultsDialog({ model, optAssemblyName, handleClose, }) {
    var _a, _b;
    const { classes } = useStyles();
    const session = getSession(model);
    const { pluginManager } = getEnv(session);
    const { assemblyManager } = session;
    let assemblyName = optAssemblyName;
    if (model.displayedRegions.length > 0) {
        assemblyName = (_a = model.displayedRegions[0]) === null || _a === void 0 ? void 0 : _a.assemblyName;
    }
    if (!assemblyName) {
        throw new Error(`Assembly name not found`);
    }
    const assembly = assemblyManager.get(assemblyName);
    if (!assembly) {
        throw new Error(`assembly ${assemblyName} not found`);
    }
    if (!assembly.regions) {
        throw new Error(`assembly ${assemblyName} regions not loaded`);
    }
    const assemblyRegions = assembly.regions;
    function handleClick(location) {
        try {
            const newRegion = assemblyRegions.find(region => location === region.refName);
            if (newRegion) {
                model.setDisplayedRegions([newRegion]);
                // we use showAllRegions after setDisplayedRegions to make the entire
                // region visible, xref #1703
                model.showAllRegions();
            }
            else {
                model.navToLocString(location, assemblyName);
            }
        }
        catch (e) {
            console.warn(e);
            session.notify(`${e}`, 'warning');
        }
    }
    function getTrackName(trackId) {
        var _a;
        if (trackId) {
            const trackConfigSchema = pluginManager.pluggableConfigSchemaType('track');
            const configuration = resolveIdentifier(trackConfigSchema, getRoot(model), trackId);
            if (configuration) {
                return (_a = configuration.name) === null || _a === void 0 ? void 0 : _a.value;
            }
        }
        return '';
    }
    return (React.createElement(Dialog, { open: true, maxWidth: "xl", onClose: handleClose },
        React.createElement(DialogTitle, null,
            "Search results",
            handleClose ? (React.createElement(IconButton, { "data-testid": "close-resultsDialog", className: classes.closeButton, onClick: () => {
                    handleClose();
                }, size: "large" },
                React.createElement(CloseIcon, null))) : null),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null, !((_b = model.searchResults) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(Typography, null,
            "No results found for ",
            React.createElement("b", null, model.searchQuery))) : (React.createElement(React.Fragment, null,
            React.createElement(Typography, null,
                "Showing results for ",
                React.createElement("b", null, model.searchQuery)),
            React.createElement(TableContainer, { component: Paper },
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "Name"),
                            React.createElement(TableCell, { align: "right" }, "Location"),
                            React.createElement(TableCell, { align: "right" }, "Track"),
                            React.createElement(TableCell, { align: "right" }))),
                    React.createElement(TableBody, null, model.searchResults.map(result => (React.createElement(TableRow, { key: `${result.getId()}` },
                        React.createElement(TableCell, { component: "th", scope: "row" }, result.getLabel()),
                        React.createElement(TableCell, { align: "right" }, result.getLocation()),
                        React.createElement(TableCell, { align: "right" }, getTrackName(result.getTrackId()) || 'N/A'),
                        React.createElement(TableCell, { align: "right" },
                            React.createElement(Button, { onClick: () => {
                                    handleClick(result.getLocation());
                                    const resultTrackId = result.getTrackId();
                                    if (resultTrackId) {
                                        model.showTrack(resultTrackId);
                                    }
                                    handleClose();
                                }, color: "primary", variant: "contained" }, "Go"))))))))))),
        React.createElement(Divider, null),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => handleClose(), color: "primary" }, "Cancel"))));
}
//# sourceMappingURL=SearchResultsDialog.js.map